import swal from "sweetalert";
import config from "../../../config";
import axiosInstance from "../../../services/AxiosInstance";
import {
  TEMPLATES_FETCH_REQUEST,
  TEMPLATES_FETCH_SUCCESS,
  TEMPLATES_FETCH_FAILURE,
  TEMPLATES_CREATE_REQUEST,
  TEMPLATES_CREATE_SUCCESS,
  TEMPLATES_CREATE_FAILURE,
  TEMPLATES_UPDATE_REQUEST,
  TEMPLATES_UPDATE_SUCCESS,
  TEMPLATES_UPDATE_FAILURE,
  TEMPLATES_DELETE_REQUEST,
  TEMPLATES_DELETE_SUCCESS,
  TEMPLATES_DELETE_FAILURE,
  TEMPLATES_SET_FILTERS,
  TEMPLATES_CLEAR_ERROR,
} from "./templatesTypes";
import formatError from "../../../services/FormatError";

// Action Creators
export const fetchTemplatesRequest = () => ({
  type: TEMPLATES_FETCH_REQUEST,
});

export const fetchTemplatesSuccess = (templates) => ({
  type: TEMPLATES_FETCH_SUCCESS,
  payload: templates,
});

export const fetchTemplatesFailure = (error) => ({
  type: TEMPLATES_FETCH_FAILURE,
  payload: error,
});

export const createTemplateRequest = () => ({
  type: TEMPLATES_CREATE_REQUEST,
});

export const createTemplateSuccess = (template) => ({
  type: TEMPLATES_CREATE_SUCCESS,
  payload: template,
});

export const createTemplateFailure = (error) => ({
  type: TEMPLATES_CREATE_FAILURE,
  payload: error,
});

export const updateTemplateRequest = () => ({
  type: TEMPLATES_UPDATE_REQUEST,
});

export const updateTemplateSuccess = (template) => ({
  type: TEMPLATES_UPDATE_SUCCESS,
  payload: template,
});

export const updateTemplateFailure = (error) => ({
  type: TEMPLATES_UPDATE_FAILURE,
  payload: error,
});

export const deleteTemplateRequest = () => ({
  type: TEMPLATES_DELETE_REQUEST,
});

export const deleteTemplateSuccess = (templateId) => ({
  type: TEMPLATES_DELETE_SUCCESS,
  payload: templateId,
});

export const deleteTemplateFailure = (error) => ({
  type: TEMPLATES_DELETE_FAILURE,
  payload: error,
});

export const setTemplatesFilters = (filters) => ({
  type: TEMPLATES_SET_FILTERS,
  payload: filters,
});

export const clearTemplatesError = () => ({
  type: TEMPLATES_CLEAR_ERROR,
});

// Thunk Actions
export const fetchTemplates = () => {
  return async (dispatch) => {
    dispatch(fetchTemplatesRequest());

    try {
      const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result
        ?.token;

      const data = await axiosInstance({
        url: config.routes.createTemplateApi,
        method: "get",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => {
          dispatch(fetchTemplatesSuccess(response?.data?.result || [])); // Debug response headers

          return response;
        })
        .catch((error) => {
          console.log("Error Response:", error.response); // Debug error response
          // swal("Error", "Failed to create template", "error");
          formatError(error.response?.data?.error);
          throw error;
        });
    } catch (error) {
      const apiError = {
        message: "Failed to fetch templates",
        code: "FETCH_ERROR",
      };
      dispatch(fetchTemplatesFailure(apiError));
    }
  };
};

export const createTemplate = (templateData) => {
  return async (dispatch) => {
    dispatch(createTemplateRequest());

    try {
      const newTemplate = {
        // id: Date.now().toString(),
        event_type: templateData.event_type || "",
        media: templateData.media || "email",
        lang_id: templateData.language || "en",
        subject: templateData.subject,
        content: templateData.content || "",
        // placeholders: templateData.placeholders || [],
        createdAt: new Date().toISOString(),
        // updatedAt: new Date().toISOString(),
      };
      const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result
        ?.token;

      const data = await axiosInstance({
        url: config.routes.createTemplateApi,
        method: "post",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        data: newTemplate,
      })
        .then((response) => {
          console.log("Response Headers:", response.headers); // Debug response headers
          swal("Success", "Template Created successfully", "success");

          return response;
        })
        .catch((error) => {
          console.log("Error Response:", error.response); // Debug error response
          // swal("Error", "Failed to create template", "error");
          formatError(error.response?.data?.error);
          throw error;
        });

      dispatch(createTemplateSuccess(data.data.result));
    } catch (error) {
      const apiError = {
        message: "Failed to create template",
        code: "CREATE_ERROR",
      };
      dispatch(createTemplateFailure(apiError));
    }
  };
};

export const updateTemplate = (templateId, templateData) => {
  return async (dispatch) => {
    dispatch(updateTemplateRequest());

    try {
      const updatedTemplate = {
        ...templateData,
        id: templateId,
        updatedAt: new Date().toISOString(),
      };
      const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result
        ?.token;

      const data = await axiosInstance({
        url: config.routes.updateTemplateApi(templateId),
        method: "put",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        data: updatedTemplate,
      })
        .then((response) => {
          swal("Success", "Template updated successfully", "success");
          dispatch(updateTemplateSuccess(updatedTemplate));
          return response;
        })
        .catch((error) => {
          console.log("Error Response:", error.response); // Debug error response
          // swal("Error", "Failed to create template", "error");
          formatError(error.response?.data?.error);
          throw error;
        });
    } catch (error) {
      const apiError = {
        message: "Failed to update template",
        code: "UPDATE_ERROR",
      };
      dispatch(updateTemplateFailure(apiError));
    }
  };
};

export const deleteTemplate = (templateId) => {
  return async (dispatch) => {
    dispatch(deleteTemplateRequest());

    try {
      // Simulate API call
      const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result
        ?.token;
      await axiosInstance({
        url: config.routes.deleteTemplateApi(templateId),
        method: "delete",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => {
          dispatch(deleteTemplateSuccess(templateId));
        })
        .catch((error) => {
          formatError(error.response?.data?.error);
          throw error;
        });
    } catch (error) {
      const apiError = {
        message: "Failed to delete template",
        code: "DELETE_ERROR",
      };
      dispatch(deleteTemplateFailure(apiError));
    }
  };
};
